import Standard from "./variants/Standard";
import MultiSelect from "./variants/MultiSelect";

export * from "./types";
export default {
  Standard,
  MultiSelect,
};
